const NotAuthorized = () => {
  return (
    <div className="text-center h-[100vh] flex items-center space-y-10 flex-col justify-center bg-[radial-gradient(circle_at_20%_10%,_#5f5f5f,_#0b0b0b,_#000000,_#000000)] text-white">
      <h1 className="text-3xl text-white dark:text-primary-gradient">
        401 - Unauthorized
      </h1>
      <p>You must be logged in to access this page.</p>
      <a href="/">
        <button className="inline-flex justify-center px-4 py-2 dark:text-black items-center gap-1 text-sm font-medium bg-lightPrimary text-white dark:button-primary-gradient rounded-md focus:outline-none">
          Go to the sign in page
        </button>
      </a>
    </div>
  );
};

export default NotAuthorized;
